module.exports = __webpack_public_path__ + "static/media/new-back-login.c7157005.jpg";